"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var Button = function (_a) {
    var href = _a.href, onClick = _a.onClick, loading = _a.loading, _b = _a.size, size = _b === void 0 ? 'normal' : _b, styled = _a.styled, _c = _a.customTextColor, customTextColor = _c === void 0 ? false : _c, _d = _a.preventDefault, preventDefault = _d === void 0 ? true : _d, props = __rest(_a, ["href", "onClick", "loading", "size", "styled", "customTextColor", "preventDefault"]);
    var baseClasses = "mt-0 cursor-pointer whitespace-nowrap rounded-full no-underline flex flex-row items-center justify-center gap-2";
    var isStyled = styled !== false;
    var classes = (0, classnames_1.default)(baseClasses, props.class, {
        "text-white": !customTextColor,
        'pointer-events-none': !!loading,
        'py-3 px-6 text-sm sm:text-base': size === 'normal',
        'py-2 px-5 text-xs sm:text-sm': size === 'small'
    });
    var content = loading ? (0, jsx_runtime_1.jsx)("img", { class: "animate-spin duration-500 w-[20px]", src: "/assets/images/spinner.svg", alt: "spinner" }) : props.children;
    var isPlaceholderHref = !href || href.trim().toLowerCase().startsWith('javascript:');
    if (isPlaceholderHref) {
        return (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", onClick: function () {
                if (onClick && !loading)
                    onClick();
            } }, props, { class: isStyled ? classes : '' }, { children: content }));
    }
    return (0, jsx_runtime_1.jsx)("a", __assign({ onClick: function (event) {
            if (onClick) {
                if (preventDefault)
                    event.preventDefault();
                if (!loading)
                    onClick();
            }
        }, href: href }, props, { class: isStyled ? classes : '' }, { children: content }));
};
exports.default = Button;
